/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import EventNoteIcon from "@material-ui/icons/EventNote";
import { useIsAdmin } from "../../../../../app/hooks/useIsAdmin";

export function AsideMenuList({ layoutProps }) {
	const location = useLocation();
	const isAdmin = useIsAdmin();
	const getMenuItemActive = (url, hasSubmenu = false) => {
		return checkIsActive(location, url)
			? ` ${!hasSubmenu &&
					"menu-item-active"} menu-item-open menu-item-not-hightlighted`
			: "";
	};

	return (
		<>
			{/* begin::Menu Nav */}
			<ul className={`menu-nav ${layoutProps.ulClasses}`}>
				{/*begin::1 Level*/}
				<li
					className={`menu-item ${getMenuItemActive(
						"/dashboard",
						false
					)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/dashboard">
						<span className="svg-icon menu-icon">
							<SVG
								src={toAbsoluteUrl(
									"/media/svg/icons/Design/Layers.svg"
								)}
							/>
						</span>
						<span className="menu-text">Dashboard</span>
					</NavLink>
				</li>
				<li className="menu-section">
					<h4 className="menu-text">DINÁMICA</h4>
					<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
				</li>
				<li
					className={`menu-item ${getMenuItemActive(
						"/sessions",
						false
					)} ${getMenuItemActive(
						"/edit-session",
						false
					)} ${getMenuItemActive("/session", false)}`}
					aria-haspopup="true"
				>
					<NavLink className="menu-link" to="/sessions">
						<span className="menu-icon">
							<EventNoteIcon />
						</span>
						<span className="menu-text">Sesiones</span>
					</NavLink>
				</li>
				{isAdmin && (
					<>
						<li className="menu-section">
							<h4 className="menu-text">GESTIÓN</h4>
							<i className="menu-icon ki ki-bold-more-hor icon-md"></i>
						</li>
						<li
							className={`menu-item ${getMenuItemActive(
								"/admins",
								false
							)} ${getMenuItemActive("/edit-admin", false)}`}
							aria-haspopup="true"
						>
							<NavLink className="menu-link" to="/admins">
								<span className="menu-icon">
									<AssignmentIndIcon />
								</span>
								<span className="menu-text">Administradores</span>
							</NavLink>
						</li>
					</>
				)}
				{/*end::1 Level*/}
			</ul>

			{/* end::Menu Nav */}
		</>
	);
}
